import request from '@/utils/request'

export function roleShopSelect(roleId) {
  return request({
    url:'/sys/roleShop/'+roleId,
    method: 'get'
  })
}
